module.exports = "<span>{{equity}}</span>";